import img from "../../img/Logo.svg";
import {
  ContainerModules,
  ContainerRegister,
  FormButton3,
  FormRegister,
} from "./styles";

import { api } from "../../services/api";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory, Redirect } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

export const Register = ({ login }) => {
  const history = useHistory();

  const schema = yup.object().shape({
    name: yup.string().required("Nome obrigatório!").min(4, "Mínimo 4 letras!"),

    email: yup
      .string()
      .required("E-mail obrigatório!")
      .email("E-mail inválido!"),

    password: yup
      .string()
      .required("Senha obrigatória!")
      .min(8, "Mínimo de 8 characters!")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
        "Obrigatório: Letra maiúscula, número e character especial"
      ),

    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password")], "Senhas diferentes!")
      .required("Senha obrigatória!"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  console.log(errors);

  const singinPage = () => {
    history.push("/");
  };

  const RegisterSubmit = ({
    name,
    email,
    password,
    contact = "undefined",
    course_module = "undefined",
    bio = "undefined",
  }) => {
    const user = { name, email, password, contact, course_module, bio };
    api
      .post("/users", user)
      .then((_) => {
        toast.success("Sucesso ao criar sua conta!");
        return history.push("/");
      })
      .catch((err) =>
        toast.error("Erro ao criar sua conta, tente outro email")
      );
    if (login) {
      return <Redirect to="/user/:user_id" />;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <ContainerRegister>
        <header>
          <figure>
            <img src={img} alt="logo" />
          </figure>
          <button onClick={() => singinPage()}>Voltar</button>
        </header>

        <FormRegister onSubmit={handleSubmit(RegisterSubmit)}>
          <h1>Crie sua conta</h1>
          <p>Rapido e grátis, vamos nessa!</p>

          <div>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Digite seu nome"
              {...register("name")}
            />
            {errors.name && <span>{errors.name.message}</span>}
          </div>

          <div>
            <label>E-mail</label>
            <input
              type="email"
              placeholder="Digite seu email"
              {...register("email")}
            />
            {errors.email && <span>{errors.email.message}</span>}
          </div>

          <div>
            <label>Senha</label>
            <input
              type="password"
              placeholder="Digite sua senha"
              {...register("password")}
            />
            {errors.password && <span>{errors.password.message}</span>}
          </div>

          <div>
            <label>Confirmar Senha</label>
            <input
              type="password"
              placeholder="Confirme sua senha"
              {...register("confirmPassword")}
            />
            {errors.confirmPassword && (
              <span>{errors.confirmPassword.message}</span>
            )}
          </div>

          <ContainerModules>
            <div>
              <label>Selecionar módulo</label>
              <select id="modules">
                <option value="module1">
                  Primeiro Módulo(Introdução ao Frontend)
                </option>
                <option value="module2">
                  Segundo Módulo(Frontend Avançado)
                </option>
                <option value="module3">
                  Terceiro Módulo(Introdução ao Backend)
                </option>
                <option value="module4">Quarto Módulo(Backend Avançado)</option>
              </select>
            </div>
          </ContainerModules>

          <FormButton3 type="submit">Cadastrar</FormButton3>
        </FormRegister>
      </ContainerRegister>
    </motion.div>
  );
};
